import { useFormikContext } from 'formik';
import get from 'lodash/get';
import React from 'react';

import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

import { EventOccurred } from './EventOccurred';
import { EventSelect } from './EventSelect';

interface EventOccurredRuleProps {
  base: string;
  readOnly?: boolean;
}

export const EventOccurredRule = ({ base, readOnly }: EventOccurredRuleProps) => {
  const { values } = useFormikContext<DefinitionFormikValues>();
  const eventNamePath = `${base}.EventOccurred.eventName`;
  const operationTypePath = `${base}.EventOccurred.operation.type`;

  const value = get(values, eventNamePath);

  return (
    <>
      <EventSelect base={base} name={eventNamePath} readOnly={readOnly} />
      {value && value !== '' && (
        <EventOccurred base={base} name={operationTypePath} readOnly={readOnly} />
      )}
    </>
  );
};
